import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onBeforeUnmount } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DisconnectConfirmDialog',
  props: {
    connectorName: null,
    isDisconnecting: { type: Boolean }
  },
  emits: ["confirm", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'confirm', keepArticles: boolean): void;
  (e: 'cancel'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  connectorName: string;
  isDisconnecting?: boolean;
}





const dialogRoot = ref<HTMLElement | null>(null);
const keepArticles = ref(true);

onMounted(() => {
  if (dialogRoot.value) {
    document.body.appendChild(dialogRoot.value);
  }
});

onBeforeUnmount(() => {
  if (dialogRoot.value && dialogRoot.value.parentNode === document.body) {
    document.body.removeChild(dialogRoot.value);
  }
});

function handleConfirm() {
  emit('confirm', keepArticles.value);
}

function handleCancel() {
  if (!props.isDisconnecting) {
    emit('cancel');
  }
}

return { __sfc: true,props, emit, dialogRoot, keepArticles, handleConfirm, handleCancel }
}

})